<template>
  <div class='SelectCateg'>
    <select @change="filter">
      <option value="">Categorias</option>
      <option
      v-for="(c, k) in Categs"
      :key="k"
      :value="c.name"
      :selected="c.name === FilterProdPainel.categoria"
      >
        {{ c.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SelectCateg',
  computed: {
    ...mapGetters(['Categorias', 'FilterProdPainel']),
    Categs () {
      return this.Categorias.filter(c => c.name !== '')
    }
  },
  methods: {
    ...mapActions(['GetCategory', 'GetProduct', 'Loading', 'changeFilterProdPainel']),
    filter (e) {
      this.Loading(true)
      this.changeFilterProdPainel({ categoria: e.target.value })
      this.GetProduct({ params: { last: 0, limit: 15, categoria: e.target.value, status: this.FilterProdPainel.status }, init: true })
      .then(res => {
        this.produtos = res
        this.Loading(false)
      })
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.SelectCateg {
  width: 30%;
  margin-left: 15px;
}

select {
  width: 100%;
  padding: 3%;
  margin-top: -4%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  font-size: 18px;
}

@media (max-width: 500px) {
  .SelectCateg {
    width: 95%;
    margin-left: 3%;
  }
}
</style>
